module.exports = __webpack_public_path__ + "img/SmokeSensation.bb6fc8fc.png";